import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { setUserEmail, setUserName } from '../../app/features/userSlice';

const SamlCallback = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { search } = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(search);
    const name = params.get('name');
    const email = params.get('email');
    const error = params.get('error');

    if (name && email) {
      dispatch(setUserName(name));
      dispatch(setUserEmail(email));
    }
    if (error){
      alert("Error in login session. Please contact IT department it@aquinasnetwork.tech")
    }

    navigate('/articles', { replace: true });
  }, [search, navigate, dispatch]);

  return null;
};

export default SamlCallback;
